import { Component, ViewChild, Inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator, MatSort, MatTableDataSource, MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Subscription } from 'rxjs/Subscription';

import { fuseAnimations } from '../../../../../../../core/animations';

import { spekwo, displayValues, toastMsg, spekWalk, stripeStatus, checkoutFields } from '../../../../utils/index';

import { EcommerceOrdersService } from '../../orders.service';
import { CommonOrdersService } from '../../commonOrders.service';

import { StripeInvoiceQueryService } from '../../../../queryFiles/index';

import { ToastComponent } from '../../../../common/toast.component';
//Order Detild Edit Modal Component
import { OrderDetailsEditComponent } from '../order-details-edit/order-details-edit.component';


@Component({
    selector: 'order-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss'],
    animations: fuseAnimations,
    providers: []
})

export class OrderDetailsComponent {

    displayValues = displayValues;
    spekwoValues = spekwo;
    toastMsg = toastMsg;
    spekCallValues = spekWalk.categoryDisplayValue;
    stripeStatus = stripeStatus;
    checkoutFields = checkoutFields;

    currentOrderId: number;
    buyerProperty: string;

    detailedColumns = [
        'agentName',
        'clientName',
        'agentType',
        'agent',
        'agentEmail',
        'contact',
        'propertyAdd',
        'product',
        // 'specificItems',
        'dueDate',
        'clientRole',
        'addEmail',
        'payment',
        'edit'
    ];
    ordersDataSource: MatTableDataSource<any>; //Used any to avoid build error
    @ViewChild(MatPaginator) ordersDetailsPaginator: MatPaginator;
    @ViewChild(MatSort) detailsSort: MatSort;

    orderCount: number;
    product: string;

    showSpinner: boolean = false;
    isDetailsLoading: boolean = false;

    allStripedata = [];
    allStripedataFromPhp = [];
    allChargesFromPhp = [];
    allOrders = [];
    categories = [];

    isDueDate: boolean = false;
    selected: any;
    currentRowSelected: any;

    currentPageIndex: number = 0;
    itemsPerPage: number = 10; //Initially load data per page

    paramsSubscription: Subscription;
    finalProcessedOrderSubscription: Subscription;
    onOrderInfoSelectedSubscription: Subscription;

    constructor(
        public route: ActivatedRoute,
        public dialog: MatDialog,

        /**Service file */
        public ecommerceOrdersService: EcommerceOrdersService,
        // public commonOrdersService: CommonOrdersService,

        /** Query file*/
        public stripeInvoiceQueryService: StripeInvoiceQueryService,

        /** Local component */
        public toastComponent: ToastComponent
    ) {
    }
    ngOnInit() {
        this.isDetailsLoading = true;

        // get current order from params
        this.paramsSubscription = this.route.params.subscribe(params => {
            this.currentOrderId = params.id;
        });

        //Final order details from 'Orders-list' page
        // this.finalProcessedOrderSubscription =
        //     this.commonOrdersService.finalProcessedOrder.subscribe(data => {
        //         // console.log('data', data);
        //         if (!data.loading) {
        //             this.allOrders = data.orders;

        //             if (this.currentOrderId) {
        //                 this.getAllInvoices();
        //             }

        //         } else {
        //             this.isDetailsLoading = true;

        //         }

        //     }, () => {
        //         this.isDetailsLoading = false;
        //     })

        this.onOrderInfoSelectedSubscription =
            this.ecommerceOrdersService.onOrderInfoSelected.subscribe(selected => {
                console.log('selected', selected);
                if (!selected.loading) {
                    this.currentRowSelected = selected;

                    // On order details screen - Currently pointed out selecetd screen
                    this.selected = selected.orderId;

                    //Final order details from 'Orders-list' page
                    this.allOrders = new Array(selected.currentValue); //Convert object into array

                    if (this.currentOrderId) {
                        this.getAllInvoices();
                    }

                    // var index = _.findIndex(this.allOrders, { id: selected.orderId }); //Based on array Index of matched row
                    // this.currentPageIndex = Math.floor(index / this.itemsPerPage); //Based on matched row,  get pageIndex
                    // console.log('currentPageIndex', this.currentPageIndex);

                    //Its worked same pagesize used in order-list & order details ..If order list change/reduce page size,current page index not correect
                    // this.currentPageIndex = selected.currentPageIndex; 

                } else {
                    this.isDetailsLoading = true;
                }

            }, () => {
                this.isDetailsLoading = false;
            });

        // Get all possible values for spek-call products 
        for (var key in this.spekCallValues) {
            this.categories.push(this.spekCallValues[key]);
        }

    }

    /**
   * Set the paginator and sort after the view init since this component will
   * be able to query its view for the initialized paginator and sort.
   */
    ngAfterViewInit() {

        if (this.ordersDataSource) {

            // this.ordersDetailsPaginator.pageIndex = this.currentRowSelected && this.currentRowSelected.currentPageIndex; //Pointing correct index old
            this.ordersDetailsPaginator.pageIndex = this.currentPageIndex; //Pointing correct index
            this.ordersDataSource.paginator = this.ordersDetailsPaginator;
            this.ordersDataSource.sort = this.detailsSort;
        }

    }

    ngOnDestroy() {
        this.paramsSubscription.unsubscribe();
        // this.finalProcessedOrderSubscription.unsubscribe();
        this.onOrderInfoSelectedSubscription.unsubscribe();
    }

    /** Based on row select- Highlight row */
    onSelect(selected) {
        this.selected = selected.id;
    }
    editOrderInfo(order,index) {
        const modal = this.dialog.open(OrderDetailsEditComponent,
            {
              data: order,
              width: 'calc(100% - 30%)',
              height: 'calc(100% - 25%)',
            },);
        modal.afterClosed().subscribe((editRes) => {
            if (editRes) {
                this.allOrders[0].solEmail = editRes.additialEmailToSe;
                this.allOrders[0].buyerProperty = editRes.address;
                this.allOrders[0].email = editRes.email;
                this.allOrders[0].agentName = editRes.agentName;
                this.allOrders[0].phone = editRes.agentPhone;
                this.allOrders[0].agentType = editRes.agentType;
                this.allOrders[0].clientName = editRes.clientName;
                this.allOrders[0].first_name= editRes.customerName;
                this.allOrders[0].agentEmail= editRes.agentEmail;
                this.allOrders[0].clientPropertyRole= editRes.clientRole;
                this.assignDataSource(this.allOrders);
          }
        });
    }


    // Get all stored stripes details  from backend
    getAllInvoices() {
        console.log('getAllInvoices');
        this.allStripedata = [];
        this.ecommerceOrdersService.GetAllStripeInvoice()
            .then((stripedata: any) => {

                this.allStripedata = stripedata;
                this.assigStripeDetails(this.allStripedata);

            })
            .catch(err => {

            })
    }

    //Finally Assign status
    async assigStripeDetails(allStripedata) {

        if (this.allOrders.length > 0) {


            await _.each(this.allOrders, (data, key) => {
                // Finally get order status
                var findResult = _.find(allStripedata, { orderId: data.id });

                var findResultInvoiceJson = findResult && findResult.invoiceObject ? JSON.parse(findResult.invoiceObject) : ''; //invocie
                var findResultChargeJson = findResult && findResult.chargeObject ? JSON.parse(findResult.chargeObject) : ''; // after charge
                // console.log('findResultChargeJson', findResultChargeJson, data.id);
                const target = {
                    invoice_pdf: findResult ? findResultInvoiceJson && findResultInvoiceJson.invoice_pdf : '-',
                    invoiceStatus: findResult ? findResultInvoiceJson && findResultInvoiceJson.status : '',
                    invoiceLink: findResult ? findResultInvoiceJson && findResultInvoiceJson.hosted_invoice_url : '',
                    receiptUrlOfInvoice: findResult ? findResultInvoiceJson && findResultInvoiceJson.receipt_url : '',
                    receiptUrlOfCheckout: findResult ? findResultChargeJson && findResultChargeJson.receipt_url : '',
                    fromInvoice: findResultInvoiceJson ? true : (findResultChargeJson && findResultChargeJson.invoice) ? true : false,
                    showSpinner: false,
                };
                // Finally assign order status with existing object
                Object.assign(data, target);

                if (this.allOrders.length == (key + 1)) {
                    // console.log('this.allOrders[0]', this.allOrders[0]);
                    this.assignDataSource(this.allOrders);

                }
            })
        }
        else {
            this.assignDataSource(this.allOrders);
        }

    }

    // Get apdf file for order
    getPdfFile(index, orderId) {

        var check = _.find(this.allStripedata, { orderId: orderId })
        return check && check.invoiceObject ? check.invoiceObject.invoice_pdf : '-';
    }

    // Popup for getting amount
    openAmountPopup(order) {

        var fromIndex = _.findIndex(this.allOrders, { id: order.id });

        const dialogRef = this.dialog.open(AmountPopupComponent, {
            width: '500px',
            data: {
                currentOrderId: order.id,
                amount: order.totalAmount, //Pass amount from checkout,
                from: 'Amount'
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (!result) {
                this.commonCallingFunction(fromIndex);
                return;
            }

            const actionType: string = result[0];

            switch (actionType) {
                /**
                 * Save
                 */
                case 'save':

                    const amount: string = result[1];
                    // Calling stripe invoice
                    this.stripeInvoice(order, fromIndex, amount);
                    break;

                case 'cancel':

                    // console.log('actionType', actionType, fromIndex);
                    this.commonCallingFunction(fromIndex);
                    break;

            }

        });
    }

    // Create invoice
    stripeInvoice(order, fromIndex, amount) {

        var checkDetail = _.find(this.allStripedata, { orderId: order.id });

        if (!checkDetail) {

            this.buyerProperty = order.buyerProperty;
            this.product = order.product_name;

            let data = {
                email: order.invoiceEmail ? encodeURIComponent((order.invoiceEmail).trim()) : encodeURIComponent((order.email).trim()), //If client invoice email use that one
                name: order.invoiceName ? encodeURIComponent(order.invoiceName) : encodeURIComponent(order.first_name), //If client invoice name use that one
                amount: Number(amount),
                product: encodeURIComponent(this.product),
                phone: encodeURIComponent(order.phone),
                city: encodeURIComponent(order.city),
                country: encodeURIComponent(order.country),
                address: encodeURIComponent(this.buyerProperty),
                postal_code: encodeURIComponent(order.postcode),
                state: encodeURIComponent(order.state),
                orderId: order.id
            }

            console.log(data, 'data');

            this.ecommerceOrdersService.stripeInvoiceToCustomer(data)
                .then((cusData: any) => {

                    if (cusData && cusData.status == this.checkoutFields.invoiceCompleteStatus) {

                        this.showToast('success');
                        // this.allOrders[fromIndex].showSpinner = false;
                        this.getAllInvoices(); //after scompelte,again refetch query

                    } else {
                        this.showToast('failed');

                        this.commonCallingFunction(fromIndex);
                    }

                })
                .catch(err => {

                    this.commonCallingFunction(fromIndex);
                    this.showToast('failed');
                    console.log(err, 'err');
                })

        }

    }


    commonCallingFunction(fromIndex) {
        this.allOrders[fromIndex].showSpinner = false;
        this.assignDataSource(this.allOrders);
    }

    //Assign data source
    async assignDataSource(orders) {
        this.isDetailsLoading = false;
        this.ordersDataSource = await new MatTableDataSource(orders);
        this.ordersDataSource.paginator = this.ordersDetailsPaginator;
        this.ordersDataSource.sort = this.detailsSort;
        this.orderCount = orders.length;

        // console.log('this.ordersDueDate', orders);
    }

    //Show toast message
    showToast(message) {

        this.toastComponent.showToast(message == 'success' ?
            this.toastMsg.invoiceSuccess :
            this.toastMsg.invoiceFailed);
    }

    openReceipt(link) {

        link ? window.open(link, '_blank') :
            this.toastComponent.showToast(this.toastMsg.noReceipt);


    }
    openPdf(link, order) {

        // For cost greated than  0.For cost 0 no charge object created
        if (order.totalAmount > 0) {

            if (order && order.receiptUrlOfCheckout) { //check invoice link
                window.open(order.receiptUrlOfCheckout, '_blank');  //get final charge link after paid

            }
            else if (order && order.receiptUrlOfInvoice) {
                window.open(order.receiptUrlOfInvoice, '_blank'); //get final invoice link after paid
            }
            else {

                order.invoiceLink ? window.open(order.invoiceLink, '_blank') :
                    this.toastComponent.showToast(this.toastMsg.noReceipt);
            }

        } else {
            order.invoiceLink ? window.open(order.invoiceLink, '_blank') :
                this.toastComponent.showToast(this.toastMsg.noReceipt);
        }

    }

    // Bring email id when status is 'Awaiting'
    bringEmail(order) {

        const dialogRef = this.dialog.open(AmountPopupComponent, {
            width: '500px',
            data: {
                from: 'Email',
                email: order.invoiceEmail,
                order: order
            }
        });
        dialogRef.afterClosed().subscribe(result => {

            if (!result) {
                return;
            }

        });
    }

}


@Component({
    selector: 'amount-popup',
    templateUrl: './amount-popup.component.html',
    styleUrls: ['./amount-popup.component.scss'],
    animations: fuseAnimations,
    providers: []
})

export class AmountPopupComponent {

    amount: number;
    displayValues = displayValues;
    from: string;
    email: string;
    order: any;

    constructor(
        public dialogRef: MatDialogRef<AmountPopupComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,

    ) {
        this.amount = this.data && this.data.amount;
        this.from = this.data && this.data.from;
        this.email = this.data && this.data.email;
        this.order = this.data && this.data.order;
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    saveAmount() {

        this.dialogRef.close(['save', this.amount]);

    }

    cancel() {
        this.dialogRef.close(['cancel', '']);
    }

};


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/order-list/order-details/order-details.component.ts